(function($) {
	'use strict';
	$.widget('msv.dropdownSearch', {
		options: {
			limit: 6,
			textField: '.form-item-text',
			optionsList: '.form-datalist__options',
			pointer: '.form-datalist__pointer',
			input: 'input[type=hidden]',
			removeBtn: '<a class="btn-remove-it icon-cross"></a>',
			removeBtnClass: '.remove-it'
		},
		vars: {},
		el: {},
		_create: function() {
			//---------- define vars and elements -----------------------------
			var self = this;
			self.vars = {};
			self.vars.dataSource = self.element.data('json'); //example: [{"value":1,"text":"one"},{"value":2,"text":"two"}]
			self.vars.fieldName = self.element.data('name');
			self.vars.required = self.element.data('required');
			self.vars.filteredDataSource = self.vars.dataSource;
			self.vars.enableScroll = self.element.data('enable-scroll');
		},
		_init: function() {
			var self = this;
			var textField = self.element.find(self.options.textField);
			textField.click(function(e) {
				self.filterBy($(e.target).val());
				self.populate();
				self.open();
			});
			textField.keydown(function(e) {
				if (e.keyCode == 9 && self.vars.filteredDataSource.length == 1) {
					textField.val(self.vars.filteredDataSource[0].text);
					self.element.find(self.options.input).val(self.vars.filteredDataSource[0].value);
				}
			});

			textField.keyup(function(e) {
				//console.log('text keyup');
				self.filterBy(textField.val());
				self.populate();
				self.open();
			});
			textField.blur(function(e) {
				setTimeout(function() {
					self.close();
				}, 200);
			});
			self.element.find(self.options.pointer).mouseup(function() {
				if (self.element.hasClass("opened")) {
					self.close();
				}
				else {
					self.filterBy(textField.val());
					self.populate();
					self.open();
				}
			});

			self.element.find(self.options.optionsList).off('click').on('click', function(item) {
				if (self.element.find(self.options.optionsList)[0] == item.target)
					return false;

				self.updateValue(item);
			});

			$(window).resize(function() {
				self.redraw();
			});

			if (self.vars.enableScroll) {
				self.element.find(self.options.optionsList)
					.css({ 'overflow-y': 'auto', 'max-height': '300px' });
			}
		},
		updateValue: function(selectedOption) {
			var self = this;
			var inputHidden = self.element.find(self.options.input);
			var textField = self.element.find(self.options.textField);
			if (typeof(selectedOption) != 'undefined') {
				textField.val($(selectedOption.target).text());
				inputHidden.val($(selectedOption.target).data('value')).trigger('change');
			}
			else {
				textField.val(null);
				inputHidden.val(null).trigger('change');
			}

			if (inputHidden.val()) {
				self.element.find('.btn-remove-it').remove();
				self.element.addClass('has-value');
				self.vars.btnRemove = $(self.options.removeBtn).off('click').click(function() {
					self.updateValue();
				});
				self.element.append(self.vars.btnRemove);

				inputHidden.valid();
				inputText.valid();
			}
			else {
				self.element.removeClass('has-value');
				self.element.find('.btn-remove-it').remove();
			}
		},
		_destroy: function() {},
		open: function() {
			var self = this;
			self.element.addClass("opened");
			self.redraw();
			self.element.find(self.options.textField).focus();
		},

		close: function() {
			var self = this;
			self.element.removeClass("opened");

			var textExists = false;
			self.vars.filteredDataSource.forEach(function(item) {

				if (item.text == self.element.find(self.options.textField).val()) {
					textExists = true;
					if (self.element.find(self.options.textField).valid)
						self.element.find(self.options.textField).valid();
				}


			});

			if (!textExists) {
				self.element.find(self.options.textField).val('');
				self.element.find(self.options.input).val('');
			}
		},

		redraw: function() {
			var self = this;
			self.element.find(self.options.optionsList).width(self.element.find(self.options.textField).width() + 2);
		},
		populate: function() {
			var self = this;
			self.element.find(self.options.optionsList).empty();
			if (!self.vars.filteredDataSource || self.vars.filteredDataSource.length === 0) {
				self.element.find(self.options.optionsList).append("<span>Sem resultados.</span>");
			}
			else {
				$.each(self.vars.filteredDataSource, function(index, item) {
					var option = $('<div class="form-datalist-item" data-value="' + item.value + '">' + item.text + "</div>");
					option.click(self, function(e) {
						var mapElementId = $(e.data.element).data('bind-map');
						if (mapElementId)
							$(mapElementId).googlemap('focusMarkerById', item.value);
					});
					self.element.find(self.options.optionsList).append(option);
					if (!self.vars.enableScroll) {
						if (index >= self.options.limit) {
							return false;
						}
					}
				});
				if (!self.vars.enableScroll) {
					if (self.vars.filteredDataSource.length > self.options.limit) {
						self.element.find(self.options.optionsList).append("<span class='milli'>Total de " + self.vars.filteredDataSource.length + " resultados encontrados.</span>");
					}
				}
			}
			self.element.find(self.options.input).addClass('has-value');
		},
		filterBy: function(inserted) {
			var self = this;
			self.vars.dataSource = self.element.data('json');
			// console.log("filterby: ", inserted);
			self.vars.filteredDataSource = [];
			if (inserted) {
				$.each(self.vars.dataSource, function(index) {
					if (self.vars.dataSource[index].text.toLowerCase().indexOf(inserted.toLowerCase()) > -1) {
						self.vars.filteredDataSource.push(self.vars.dataSource[index]);
					}
				});
			}
			else {
				self.vars.filteredDataSource = self.vars.dataSource;
			}
		},
		reset: function() {
			this.element.find(self.options.textField).val('');
			this.element.find(self.options.input).val('');
			this.filterBy('');
		}
	});
})(jQuery);